import { Component, Input, Output, EventEmitter, DestroyRef, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { NgxCurrencyDirective } from 'ngx-currency';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MdbpInputComponent } from 'app/core/components/mdb-input/mdb-input.component';
@Component({
  selector: 'app-in-kind-item-element',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    NgxCurrencyDirective, 
    MdbFormsModule, 
    MdbpInputComponent,
    ReactiveFormsModule
  ],
  templateUrl: './in-kind-item-element.component.html',
  styleUrl: './in-kind-item-element.component.scss'
})
export class InKindItemElementComponent implements OnInit {
  destroyRef = inject(DestroyRef)

  @Input() transaction: any;
  @Input() pageNumber: number;
  @Input() idx: number;
  @Output() checkmarkChange = new EventEmitter<{id: string, field: 'checked' | 'buyItNowEnabled'}>();
  @Output() valueChange = new EventEmitter<{id: string, field: 'minBid' | 'bidIncrement' | 'buyItNowAmount', control: any}>();

  public AMOUNT_LIMIT = AMOUNT_LIMIT;
  
  public form: FormGroup = new FormGroup({
    minBid: new UntypedFormControl('', [Validators.required, Validators.min(AMOUNT_LIMIT.MIN), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]),
    bidIncrement: new UntypedFormControl('', [Validators.required, Validators.min(AMOUNT_LIMIT.MIN), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]),
    buyItNowAmount: new UntypedFormControl('', [])
  });

  public imageUrl: string = ''; 
  public categories: string[] = [];

  constructor() { }

  ngOnInit(): void {
    this.form.patchValue({
      minBid: this.transaction.minBid || 0,
      bidIncrement: this.transaction.bidIncrement || 0,
      buyItNowAmount: this.transaction.buyItNowAmount || this.transaction.inKindDonationItemInfo.value || 0
    });

    this.updateBuyItNowValidators(this.transaction.buyItNowEnabled)

    const minBid = this.form.get('minBid');
    const bidIncrement = this.form.get('bidIncrement');
    const buyItNowAmount = this.form.get('buyItNowAmount');

    minBid.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.onValueChange('minBid', minBid);
    });

    bidIncrement.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.onValueChange('bidIncrement', bidIncrement);
    });

    buyItNowAmount.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.onValueChange('buyItNowAmount', buyItNowAmount);
    });

    this.imageUrl = this.transaction.inKindDonationItemInfo.images[0] || '/images/org_logo_default_v2.svg'; 
    this.categories = this.transaction.inKindDonationItemInfo.categories;
  }

  onChangeCheckmark(event: Event, field: 'checked' | 'buyItNowEnabled') {
    event.stopPropagation();

    if (field === 'buyItNowEnabled') {
      this.updateBuyItNowValidators(!this.transaction.buyItNowEnabled); // Toggle state
    }

    this.checkmarkChange.emit({
      id: this.transaction.id,
      field
    });
  }

  onValueChange(field: 'minBid' | 'bidIncrement' | 'buyItNowAmount', control: any) {
    this.valueChange.emit({
      id: this.transaction.id,
      field,
      control
    });
  }

  updateBuyItNowValidators(enabled: boolean) {
    const buyItNowAmount = this.form.get('buyItNowAmount');
    if (enabled) {
        buyItNowAmount.setValidators([
            Validators.required,
            Validators.min(AMOUNT_LIMIT.MIN),
            Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)
        ]);
    } else {
        buyItNowAmount.setValidators(null);
    }
    buyItNowAmount.updateValueAndValidity();
  }
}
